export const RCA_SEVERITY = {
  SEV1: { label: "SEV1 · Critical", short: "SEV1", chip: "bg-red-600 text-white border-red-600" },
  SEV2: { label: "SEV2 · Major", short: "SEV2", chip: "bg-orange-500 text-white border-orange-500" },
  SEV3: { label: "SEV3 · Moderate", short: "SEV3", chip: "bg-amber-100 text-amber-800 border-amber-200" },
  SEV4: { label: "SEV4 · Minor", short: "SEV4", chip: "bg-slate-100 text-slate-700 border-slate-200" },
};

export const RCA_STATUS = {
  draft: { label: "Draft", chip: "bg-slate-100 text-slate-600 border-slate-200" },
  in_review: { label: "In Review", chip: "bg-sky-50 text-sky-700 border-sky-200" },
  approved: { label: "Approved", chip: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  closed: { label: "Closed", chip: "bg-slate-800 text-white border-slate-800" },
};

export const RCA_CATEGORIES = {
  code_bug: "Code defect / bug", configuration: "Configuration change", infrastructure: "Infrastructure / hosting",
  third_party: "Third-party / vendor", process: "Process gap", human_error: "Human / operational error",
  capacity: "Capacity / performance", security: "Security", unknown: "Unknown / under investigation",
};

export const ACTION_STATUS = {
  open: { label: "Open", chip: "bg-slate-100 text-slate-600" },
  in_progress: { label: "In progress", chip: "bg-amber-100 text-amber-700" },
  done: { label: "Done", chip: "bg-emerald-100 text-emerald-700" },
};

export function toLocalInput(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return "";
  const off = d.getTimezoneOffset() * 60000;
  return new Date(d - off).toISOString().slice(0, 16);
}

export function fromLocalInput(v) {
  return v ? new Date(v).toISOString() : "";
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
}

export function duration(a, b) {
  if (!a || !b) return "—";
  const mins = Math.round((new Date(b) - new Date(a)) / 60000);
  if (mins < 0) return "invalid";
  if (mins < 60) return `${mins}m`;
  const h = Math.floor(mins / 60);
  if (h < 48) return `${h}h ${mins % 60}m`;
  return `${Math.floor(h / 24)}d ${h % 24}h`;
}
